




































import {
  Vue,
  Component
} from "@/shared/vuepack";
import { useWexDebitCardsStore } from "@/shared/store/wexDebitCards";
import { WexDebitCardManageCardViewState } from "@/shared/types";
import * as RouteNames from "@/employee/route-names";

@Component({
  components: {
  }
})
export default class WexDebitCardDeactivateCardForm extends Vue {
  wexDebitCardsStore = useWexDebitCardsStore();

  WexDebitCardManageCardViewState = WexDebitCardManageCardViewState;
  RouteNames = RouteNames;

  onSubmitChanges (e: Event) {
    e.preventDefault();
    this.wexDebitCardsStore.setWexDebitCardManageCardViewState(WexDebitCardManageCardViewState.ConfirmDeactivateCardForm);
  }
}
